import { render, staticRenderFns } from "./Receivable.vue?vue&type=template&id=7b818e4a&scoped=true"
import script from "./Receivable.vue?vue&type=script&lang=js"
export * from "./Receivable.vue?vue&type=script&lang=js"
import style0 from "./Receivable.vue?vue&type=style&index=0&id=7b818e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b818e4a",
  null
  
)

export default component.exports